export default "__VITE_ASSET__Fq7t$umG__"